import { ReactComponent as EapLogo } from '../assets/images/Caminho3926.svg';
import { ReactComponent as InsumosLogo } from "../assets/images/campo.svg";
import { Link } from 'react-router-dom';
import React from 'react';

export function TrocaTelas(props) {

  let url = window.location.href.split('/')
  React.useEffect(() => {
    let border = document.getElementById('border-options_eap')
    if (url[url.length - 1] === 'insumo') {
      // console.log('aq')
      setTimeout(() => {
        border.classList.add('width-border-size')
      }, 100);
    } else {
      setTimeout(() => {
        border.classList.remove('width-border-size')
      }, 300);
    }
  }, [])

  return (
    <div className="options-body" >
      <div className="options">
        <Link to={props.cpu ? null : props.route} className={props.cpu ? "selected-options options_eap" : "options_eap"}>
          < EapLogo />
          <span>CPU</span>
        </Link>
        <Link to={props.cpu ? props.route : null} className={!props.cpu ? "selected-options options_eap" : "options_eap"} >
          < InsumosLogo />
          <span>INSUMOS</span>
        </Link>
      </div>

      <div id='border-options_eap' className='border-options_eap' />
    </div>
  )
}
